import React from 'react';
import { Row, Spin } from 'antd';
import CustomButton from '@/components/CustomButton';

interface AgentFooterProps {
  onClose: () => void;
  validationIssues?: string[];
  saving?: boolean;
  readOnly?: boolean;
}

export const AgentFooter: React.FC<AgentFooterProps> = ({
  onClose,
  validationIssues,
  saving = false,
  readOnly = false,
}) => {
  if (readOnly) return null;

  return (
    <div className='agentFormFooter'>
      {validationIssues?.length ? (
        <p className='agentFormFooter__issues'>{validationIssues.join('; ')}</p>
      ) : null}

      <Row gutter={[0, 8]} className='agentFormFooterRow'>
        {!readOnly && (
          <CustomButton
            key='button1'
            text='Save'
            bgColor='var(--text-primary)'
            htmlType='submit'
            color='var(--surface-container)'
            fontSize='16px'
            fontWeight='600'
            boxShadow='none'
            height='48px'
            width='100%'
            borderRadius='8px'
            isFormValid={saving}
            loader={saving ? <Spin size='small' /> : undefined}
          />
        )}

        <CustomButton
          key='button2'
          text='Cancel'
          bgColor='transparent'
          color='var(--text-primary)'
          fontSize='16px'
          padding='11.5px 0px 12px 0px'
          fontWeight='600'
          boxShadow='none'
          height='auto'
          width='100%'
          border='none'
          marginTop='0px'
          onClick={onClose}
          isFormValid={saving}
        />
      </Row>
    </div>
  );
};
